import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';

const lukesPhoto = `${process.env.PUBLIC_URL}/images/Luke_Founder.jpeg`;

const AboutMeContainer = styled.div`
  padding: ${theme.spacing.section} 0;
  background: ${theme.colors.dark};
`;

const AboutMeWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const AboutMeImage = styled.div`
  flex: 1;
  max-width: 400px;
  
  @media screen and (max-width: 768px) {
    margin-bottom: 30px;
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  border-radius: ${theme.borderRadius};
  overflow: hidden;
  box-shadow: ${theme.boxShadow};
  
  &:after {
    content: '';
    position: absolute;
    top: 20px;
    right: -20px;
    width: 100%;
    height: 100%;
    border: 4px solid ${theme.colors.accent};
    border-radius: ${theme.borderRadius};
    z-index: -1;
  }
`;

const Image = styled.img`
  width: 100%;
  display: block;
`;

const AboutMeContent = styled.div`
  flex: 1;
  padding-left: 50px;
  
  @media screen and (max-width: 768px) {
    padding-left: 0;
  }
`;

const AboutMeHeading = styled.h2`
  font-size: 2.5rem;
  color: ${theme.colors.accent};
  margin-bottom: 30px;
  font-family: ${theme.fonts.heading};
  position: relative;
  
  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
  
  @media screen and (max-width: 480px) {
    font-size: 1.75rem;
  }
  
  &:after {
    content: '';
    position: absolute;
    width: 60px;
    height: 3px;
    background-color: ${theme.colors.accent};
    bottom: -10px;
    left: 0;
  }
`;

const AboutMeText = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: ${theme.colors.textLight};
  margin-bottom: 20px;
`;

const AboutMeSection = () => {
  return (
    <AboutMeContainer id="about-me">
      <AboutMeWrapper>
        <AboutMeImage>
          <ImageWrapper>
            <Image src={lukesPhoto} alt="Luke - Founder of Rewilding Therapies" />
          </ImageWrapper>
        </AboutMeImage>
        <AboutMeContent>
          <AboutMeHeading>About Me</AboutMeHeading>
          <AboutMeText>
            Hey, I'm Luke. Founder of the Rewilding Therapies. I'm a Wilderness Psychotherapist in training, 
            a WildStrong Movement coach, and someone who's walked through the mud of mental health struggles 
            and come out the other side with a deep respect for nature, movement, and the human spirit.
          </AboutMeText>
          <AboutMeText>
            My work blends psychotherapy, bushcraft, the outdoors, and somatic movement - not in a 
            "hippie dippie" kind of way, but in a real, down-to-earth, practical way that helps people 
            feel more like themselves again.
          </AboutMeText>
          <AboutMeText>
            I've worked with the NHS, local councils, schools and mental health charities. But my approach 
            doesn't follow a manual. It follows the people. We build emotional intelligence, self-esteem, 
            and authentic community - one fireside session, one honest conversation, one breath at a time.
          </AboutMeText>
          <AboutMeText>
            Whether we're sitting in a forest or crawling through the leaves, the aim is the same: to reconnect. 
            To rebuild. To remember who we are when we're not just surviving.
          </AboutMeText>
          <AboutMeText>
            <em>There's no mask needed here. Come as you are. Take what you need.</em>
          </AboutMeText>
          <AboutMeText>
            <strong>Nature's been waiting.</strong>
          </AboutMeText>
        </AboutMeContent>
      </AboutMeWrapper>
    </AboutMeContainer>
  );
};

export default AboutMeSection;